import { getToolCatalog } from '../api/mcpPermissionsApi';
import { useMenuStore } from 'vince-core/stores/menuStore';
import { Menu, SubHeader } from 'vince-core/types/menu';
import { VinceApp } from 'vince-core/composables/usePermission';
import { ResourceType } from 'vince-core/types/common';
import { Action } from 'vince-core/types/roles';

export default defineNuxtPlugin(() => {
    const store = useMenuStore();
    store.addMenuItem('mcpPermissions.menu', '/mcp-permissions', 5, Menu.ADMINISTRATION, SubHeader.ADMINISTRATION, 'pi pi-shield', {
        app: VinceApp.AI_APPS,
        resource: ResourceType.MCP_TOOL_PERMISSION,
        resourceId: '*',
        action: Action.READ
    }, undefined, async () => (await getToolCatalog()).count);
});
